<!--
 * @Author: houmy
 * @Date: 2023-09-21 11:35:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-27 15:54:33
 * @FilePath: \zx-home\src\views\ProductsDetail.vue
 * @Description: 
 * 
-->

<template>
    <div class="page">
        <Contact ref="Contact"></Contact>
        <ul class="anchorPoint">
            <li @click="scrollTo('section1')" :class="{ active: activeSection === 'section1' }">
                <p>
                    <span>
                        产品介绍
                        <i></i>
                    </span>
                </p>
            </li>

            <li v-if="detail.unit" @click="scrollTo('section2')" :class="{ active: activeSection === 'section2' }">
                <p>
                    <span>
                        部件组成
                        <i></i>
                    </span>
                </p>
            </li>

            <li v-if="detail.scene" @click="scrollTo('section3')" :class="{ active: activeSection === 'section3' }">
                <p>
                    <span>
                        应用场景
                        <i></i>
                    </span>
                </p>
            </li>

            <li v-if="detail.highlight" @click="scrollTo('section4')" :class="{ active: activeSection === 'section4' }">
                <p>
                    <span>
                        功能亮点
                        <i></i>
                    </span>
                </p>
            </li>

            <li v-if="detail.effect" @click="scrollTo('section5')" :class="{ active: activeSection === 'section5' }">
                <p>
                    <span>
                        应用效果
                        <i></i>
                    </span>
                </p>
            </li>
            <li v-if="detail.effectData" @click="scrollTo('section6')" :class="{ active: activeSection === 'section6' }">
                <p>
                    <span>
                        应用数据
                        <i></i>
                    </span>
                </p>
            </li>
            <li v-if="detail.parameters" @click="scrollTo('section7')" :class="{ active: activeSection === 'section7' }">
                <p>
                    <span>
                        技术参数
                        <i></i>
                    </span>
                </p>
            </li>
            <li v-if="detail.fitModel" @click="scrollTo('section8')" :class="{ active: activeSection === 'section8' }">
                <p>
                    <span>
                        适配机型
                        <i></i>
                    </span>
                </p>
            </li>
            <li v-if="detail.case" @click="scrollTo('section9')" :class="{ active: activeSection === 'section9' }">
                <p>
                    <span>
                        应用案例
                        <i></i>
                    </span>
                </p>
            </li>

            <div class="pointLine"></div>

        </ul>
        <div class="productDetailBanner" id="section1" ref="section1">
            <img class="productDetailBannerImg" :src="getImagePath(detail.banner)" alt="">
            <div class="bannerMain">
                <div class="detailBannerInfo" :class="[detail.bannerColorWhite ? 'whiteText' : '']">
                    <h1>{{ detail.title }}</h1>
                    <span class="productIntro">{{ detail.intro }}</span>
                    <p>{{ detail.desc }}</p>
                    <button class="commonBtn toContact detailContact" @click="onlineContact">
        <img src="../assets/img/contact2.png" alt="">产品咨询
      </button>
                </div>
            </div>
        </div>
        <div class="unitWrap" v-if="detail.unit" id="section2" ref="section2">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">部件组成</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Component composition'.toUpperCase() }}</span>

            </div>
            <ul class="unitList">
                <li v-for="item in detail.unit">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                    <p>{{ item.desc }}</p>
                </li>
            </ul>
        </div>
        <div class="unitWrap" v-else id="section3" ref="section3">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">应用场景</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Application scenarios'.toUpperCase() }}</span>

            </div>
            <ul class="unitList scenceMain">
                <li v-for="item in detail.scene">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                </li>
            </ul>
        </div>
        <div class="lightWrap" id="section4" ref="section4">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">功能亮点</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Key Features of the Product'.toUpperCase() }}</span>

            </div>
            <ul class="lightList w12">
                <li v-for="item in detail.highlight">
                    <img :src="getImagePath(item.img)" alt="">
                    <div class="textMain">
                        <b>{{ item.title }}</b>
                        <p>{{ item.desc }}</p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="effectWrap fl_100" v-if="detail.effect" id="section5" ref="section5">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">应用效果</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Use effects'.toUpperCase() }}</span>

            </div>
            <ul class="effectList w12">
                <li v-for="item in detail.effect">
                    <i v-if="item.tip" :class="[item.flag == 1 ? 'blueBg' : 'blackBg']">{{ item.tip }}</i>
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                    <p>{{ item.desc }}</p>
                    <p>{{ item.desc2 }}</p>
                    <p>{{ item.desc3 }}</p>

                </li>
            </ul>
        </div>
        <div class="effectDataWrap fl_100" v-if="detail.effectData" id="section6" ref="section6">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">应用数据</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Use effects'.toUpperCase() }}</span>

            </div>
            <p class="effectTip">
                <span v-for="item in detail.effectData.type">
                    <i :class="[item.flag == 1 ? 'blueBg' : 'grayBg']"></i>
                    {{ item.title }}
                </span>
            </p>
            <ul class="effectDataList w12">
                <li v-for="item in detail.effectData.data">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                    <p>{{ item.desc }}</p>
                </li>
            </ul>
        </div>
        <div class="fl_100" v-if="detail.parameters"
            :class="detail.parameters[0][0].type == 1 ? 'parametersWrap' : 'parametersHeightWrap'" id="section7"
            ref="section7">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">主要技术参数</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Main technical specifications'.toUpperCase() }}</span>

            </div>
            <div class="parameterMain" v-if="detail.parameters[0][0].type == 1">
                <table v-for="item in detail.parameters" border="0">
                    <thead>
                        <tr>
                            <th>参数名称</th>
                            <th>参数值</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item2 in item">
                            <td>{{ item2.name }}</td>
                            <td>{{ item2.value }}</td>
                        </tr>
                    </tbody>

                </table>
            </div>
            <div class="parameterMain" v-else>
                <table v-for="item in detail.parameters">
                    <thead>
                        <tr>
                            <th>参数名称</th>
                            <th>SDC300</th>
                            <th>SDC300Pro</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item2 in item">
                            <td>{{ item2.name }}</td>
                            <td>{{ item2.value }}</td>
                            <td>{{ item2.value2 }}</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
        <div class="fitWrap fl_100" v-if="detail.fitModel" id="section8" ref="section8">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">适配机型</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Adapted vehicle'.toUpperCase() }}</span>

            </div>
            <ul class="fitList w12">
                <li v-for="item in detail.fitModel" @click="toModelDetail(item)">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                </li>
            </ul>
        </div>

        <div class="caseWrap fl_100" v-if="detail.case" id="section9" ref="section9">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">应用案例</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Customer case'.toUpperCase() }}</span>

            </div>
            <div class="caseMain">
                <p>{{ detail.case.title }}</p>
                <div class="caseVideo">
                    <video :src="getImagePath(detail.case.video)" controls="controls" width="100%" height="100%"></video>
                </div>
            </div>
        </div>


        <div class="aboutProduct fl_100 " v-if="otherProducts && otherProducts.length > 0">
            <div class="aboutTitle w12">
                <i></i>
                <b>相关产品推荐</b>
            </div>
            <ul class="aboutList w12">
                <li v-for="item in otherProducts" @click="changeProduct(item.id, item.type)">
                    <img :src="getImagePath(item.img)" alt="">
                    <b>{{ item.title }}</b>
                    <p>
                        {{ item.desc }}
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import productJson from '@/assets/data/productList.json'
export default {
    components: {
        Contact
    },
    data() {
        return {
            allProducts: [],
            detail: {},
            otherProducts: [],
            activeSection: 'section1'
        };
    },
    watch: {
        '$route'(val, from) {
            if (val.query.id) {
                this.id = this.$route.query.id;
                this.type = this.$route.query.type;
        let currentList = `list${this.type}`;
        let currentTypeArr = this.allProducts[currentList];
        this.detail = currentTypeArr.find(item => item.id == this.id)
        this.otherProducts = currentTypeArr.filter(item => item.id != this.id)
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
            }
        }
    },
    mounted() {
        this.allProducts = productJson
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        let currentList = `list${this.type}`;
        let currentTypeArr = this.allProducts[currentList];
        this.detail = currentTypeArr.find(item => item.id == this.id)
        this.otherProducts = currentTypeArr.filter(item => item.id != this.id)
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 产品咨询
    onlineContact(){
      this.$refs.Contact.handleShowContact()
    },
        scrollTo(section) {
            const element = this.$refs[section];
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });

                // 设置当前活动的锚点
                // this.activeSection = section;
            }
        },
        handleScroll() {
            const sections = ['section1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7', 'section8', 'section9']; // 你的锚点名称列表
            const windowHeight = window.innerHeight; // 可视窗口高度
            const scrollPosition = window.scrollY;
            // 通过滚动位置来确定当前活动的锚点
            for (const section of sections) {
                const element = this.$refs[section];
                if (element) {
                    const sectionTop = element.offsetTop - 40
                    const sectionHeight = element.offsetHeight;
                    if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                        this.activeSection = section;
                    }

                }
            }
        },
        // 图片回显
        getImagePath(imageName) {
            if(imageName){
                return imageName.indexOf('aliyuncs')>-1?imageName:require(`@/assets${imageName}`)
           
        }
        },
        // 切换产品
        changeProduct(id, type) {
            this.id = id;
            this.type = type;
            let currentList = `list${this.type}`;
            let currentTypeArr = this.allProducts[currentList];
            this.detail = currentTypeArr.find(item => item.id == id)
            this.otherProducts = currentTypeArr.filter(item => item.id != this.id)
            this.$nextTick(() => {
                window.scrollTo(0, 0)
            })
        },
        toModelDetail(obj) {
            this.$router.push({
                path: '/productsModelDetail',
                query: {
                    id: this.id,
                    objId: obj.id,
                    type: obj.type
                }
            })
        }

    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/ProductsDetail.vue